// UI theme constants — shared across all game UI components

export const FONT = "'Consolas','SF Mono','Fira Code',monospace";
export const PANEL_BG = "rgba(28,30,36,0.95)";
export const BORDER = "#2a2d35";
export const TEXT = "#c8cad0";
export const TEXT_DIM = "#6a6e7a";
export const ACCENT = "#5c8cb4";
export const ROW_HOVER = "rgba(92,140,180,0.08)";
export const INPUT_BG = "#1a1c22";
